import screen1Video from "./Screen1_withBG.webm";
import animation2 from "../../assets/tutorial_screens/Tutorial_Screen2.json";
import animation3 from "../../assets/tutorial_screens/Tutorial_Screen3.json";
import animation4 from "../../assets/tutorial_screens/Tutorial_Screen4.json";

export const tutorialSteps = [
  {
    type: "video",
    source: screen1Video,
    title_en: "MISINFORMATION AFFECTS...",
    subtitle_en: "elections, health, and trust.\nBy playing, you're building skills to think critically in the digital world.",
    title_de: "FALSCHE INFORMATIONEN BEEINFLUSSEN...",
    subtitle_de: "Wahlen, Gesundheit und Vertrauen.\nDurch dieses Spiel entwickeln Sie Fähigkeiten, um in der digitalen Welt kritisch zu denken.",
    note_en: "Swipe or tap the arrow to continue through the tutorial.",
    note_de: "Wischen oder tippen Sie auf den Pfeil, um mit dem Tutorial fortzufahren.",
  },
  {
    type: "lottie",
    source: animation2,
    title_en: "HOW TO PLAY?",
    subtitle_en: "You'll be shown headlines. Tap to mark it as 'Reliable' or 'Shady'",
    title_de: "WIE SPIELT MAN?",
    subtitle_de: "Sie werden Schlagzeilen sehen. Tippen Sie, um diese als 'Vertrauenswürdig' oder 'Irreführend' zu markieren."
  },
  {
    type: "lottie",
    source: animation3,
    title_en: "COMPARE WITH OTHERS",
    subtitle_en: "See how your instincts compare with others.\nCompare your choices with others including AI judgments.",
    title_de: "VERGLEICHEN SIE MIT ANDEREN",
    subtitle_de: "Sehen Sie, wie Ihr Instinkt im Vergleich zu anderen abschneidet.\nVergleichen Sie Ihre Entscheidungen mit denen anderer, auch mit den Urteile der KI."
  },
  {
    type: "lottie",
    source: animation4,
    title_en: "DATA SHARING",
    subtitle_en: "Every choice you make in the game helps us learn how real people detect fake news.\nYour answers are anonymous - but your impact is real.\nYou're not just playing - you're contributing to the fight against misinformation",
    title_de: "DATENTEILUNG",
    subtitle_de: "Jede Entscheidung, die du im Spiel triffst, hilft uns zu lernen, wie echte Menschen Fake News erkennen.\nDeine Antworten sind anonym – aber dein Einfluss ist real.\nDu spielst nicht nur – du trägst zum Kampf gegen Fehlinformationen bei."
  },
];
